import { render } from "./projectTwelveScreen.vue?vue&type=template&id=c4d6144c"
import script from "./projectTwelveScreen.vue?vue&type=script&lang=js"
export * from "./projectTwelveScreen.vue?vue&type=script&lang=js"

import "./projectTwelveScreen.vue?vue&type=style&index=0&id=c4d6144c&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__